export default "__VITE_ASSET__spYpCuS8__"